import React from "react";

import { EnvDataContext } from "./EnvDataContextProvider";

const useEnvDataContext = () => {
  const context = React.useContext(EnvDataContext);

  if (!context) {
    throw new Error("useEnvDataContext must be used within a EnvDataProvider");
  }

  return context;
};

const useEnvData = () => useEnvDataContext().env;

export { useEnvData };
